jQuery(document).ready(function($) {

    const $contactForm = $('#contact-form');
    const $submitBtn = $contactForm.find('input[type=submit]');
    
    sendMessageAjax($, $contactForm, $submitBtn);

});


function sendMessageAjax($, $form, $submitBtn) {
    $submitBtn.on('click',function(e){
        e.preventDefault();
        sendAjax($form, ContactFormLocalizedData, function(res) {
            if ( res.success === true ) {
                $form.find('.error').remove();
                $('<div class="success">'+ContactFormLocalizedData.strings.sentMessageText+'</div>').insertAfter($form.find('[type="submit"]'));
            }
            else {
                console.log(res);
                $form.find('.success').remove();
                $('<div class="error">'+ContactFormLocalizedData.strings.error+'</div>').insertAfter($form.find('[type="submit"]'));
            }
        });
    });

}